import * as React from 'react'

import { type MediumIcon } from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Chip from 'modules/core/components/Filter/base/Chip'
import ChipWithIcon from 'modules/core/components/Filter/base/ChipWithIcon'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import { getEmployeeDisplayName } from 'modules/core/lib/employeeName'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

type Props = {
  header?: React.ReactNode
  footer?: React.ReactNode
  label: string
  value?: EmployeeForSelectFragmentNoAccess[]
  nameAttribute: string
  onValueChange: (value?: EmployeeForSelectFragmentNoAccess[]) => void
  defaultOpen?: boolean
  icon?: MediumIcon
  noFooter?: boolean
  fullWidth?: boolean
  employeeIds?: number[]
}

const EmployeeSelectorFilter = ({
  header,
  label,
  value,
  onValueChange,
  defaultOpen,
  icon,
  fullWidth,
  employeeIds,
}: Props) => {
  const isNonEmptyArray = Array.isArray(value) && value.length > 0

  const activeLabel = isNonEmptyArray
    ? value.length > 1
      ? `(${value.length})`
      : getEmployeeName(value[0])
    : ''

  return (
    <EmployeeSelector
      hideBorder
      multiple
      value={value ?? []}
      onSelect={onValueChange}
      employeeIds={employeeIds}
    >
      <Provider
        value={value}
        onValueChange={onValueChange}
        closeOnChange={false}
        defaultOpen={!!defaultOpen}
      >
        {icon ? (
          <ChipWithIcon label={label} activeLabel={activeLabel} icon={icon} />
        ) : (
          <Chip.Toggler
            active={isNonEmptyArray}
            label={label}
            activeLabel={activeLabel}
            fullWidth={fullWidth}
          />
        )}

        <Content header={header} maxWidth="s" maxHeight="s600" />
      </Provider>
    </EmployeeSelector>
  )
}

export default EmployeeSelectorFilter

const getEmployeeName = (employee?: EmployeeForSelectFragmentNoAccess) => {
  if (!employee) return ''

  return getEmployeeDisplayName({
    fullName: employee.fullName,
    lastName: employee.lastName,
    preferredName: employee.preferredName,
  })
}
